<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span> -->
            <feather-icon
              icon="SearchIcon"
              size="36"
              class="mr-50"
            />
            <span class="align-middle">Search</span>
            <b-input-group
              class="input-group-merge mx-50"
            >
              <b-form-input
                v-model="searchQuery"
                placeholder="Zone/Lot no."
              />
              <b-input-group-append
                v-if="searchQuery"
                is-text
              >
                <feather-icon
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="searchQuery = '';"
                />
              </b-input-group-append>
            </b-input-group>

            <b-input-group
              class="input-group-merge mr-50"
            >
              <b-form-input
                v-model="agentSearchQuery"
                placeholder="Agent Code/Name"
              />
              <b-input-group-append
                v-if="agentSearchQuery"
                is-text
              >
                <feather-icon
                  icon="XIcon"
                  class="cursor-pointer"
                  @click="agentSearchQuery = '';"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-dropdown
                id="dropdown-form-purchase-request"
                ref="filter_current_reservations"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <reservation-filters
                  :status.sync="statusFilter"
                  :status-options="statusOptions"
                  :created-at.sync="createdAtFilter"
                  :product.sync="productFilter"
                  :product-options="productOptions"
                  :lot-type.sync="lotTypeFilter"
                  :lot-type-options="lotTypeOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="createdAtFilter || statusFilter.length || productFilter.length || lotTypeFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-if="createdAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtFilter = ''"
                  >
                    {{ createdAtFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-for="item in productFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromProductFilter(item)"
                  >
                    <span class="text-capitalize">{{ resolveProductName(item) }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="item in lotTypeFilter"
                  :key="item"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromLotTypeFilter(item)"
                  >
                    <span class="text-capitalize">{{ item }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refCurrentReservationsTable"
        class="position-relative event_list"
        :items="reservationData"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'LotReservation')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'agencies-reservation-show', params: { id: data.item._id } }"
            >
              {{ data.item.stringID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>

        <template #cell(lot)="data">
          <div class="">
            <span>{{ data.item.lot ? data.item.lot.productType : data.item.productType }}</span>
            <br>
            <span>{{ data.item.lot ? data.item.lot.lotType : data.item.lotType }}</span>
          </div>
        </template>

        <template #cell(zone)="data">
          <div class="">
            <span>{{ data.item.lot ? data.item.lot.zoneNo : data.item.zoneNo }}-{{ data.item.lot ? data.item.lot.lotNo : data.item.lotNo }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveReservationStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(agent)="data">
          <div>
            <b-button
              v-if="canViewThisAction('show', 'Agent') && (data.item.agent && data.item.agent.agent)"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id text-uppercase"
              :to="{ name: 'agency-agents-show', params: { id: data.item.agent.agent._id } }"
            >
              {{ data.item.agent.name || '-' }}
            </b-button>
            <b-button
              v-else-if="canViewThisAction('show', 'Agent') && data.item.mainAgent"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id text-uppercase"
              :to="{ name: 'agency-agents-show', params: { id: data.item.mainAgent._id } }"
            >
              {{ data.item.mainAgent.name || '-' }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle not-button text-uppercase"
            >
              {{ data.item.agent ? data.item.agent.name : (data.item.mainAgent ? data.item.mainAgent.name : '-') }}
            </b-button>
            <br>
            <span
              class=""
            >
              {{ data.item.agent ? data.item.agent.code : (data.item.mainAgent ? data.item.mainAgent.code : '-') || '-' }}
            </span>
          </div>
        </template>

        <template #cell(reservationStartDate)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.reservationStartDate ? dateFormatWithTime(data.item.reservationStartDate) : '-' }} - </span>
            <br>
            <span>{{ data.item.reservationEndDate ? dateFormatWithTime(data.item.reservationEndDate) : 'Infinite' }}</span>
          </div>
        </template>

        <template #cell(reservationEndDate)="data">
          <div class="text-nowrap">
            <span class="">{{ getHoursMinsSeconds(data.item.reservationEndDate) }}</span>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ getCreatedBy(data.item) }}</span>
            <br>
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'LotReservation') || canViewThisAction('release', 'LotReservation') || canViewThisAction('release-staff-hold', 'LotReservation')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'LotReservation')"
              :to="{ name: 'agencies-reservation-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('release', 'LotReservation')"
              @click="showReleaseWarning(data.item._id, data.item.reservationFor)"
            >
              <feather-icon icon="XCircleIcon" />
              <span class="align-middle ml-50">Release Lot</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalReservations > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalReservations"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BBadge, BDropdown, BDropdownItem, BPagination, BButton, BFormTag,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useCurrentReservationList from './useCurrentReservationList'
import reservationStoreModule from '../reservationStoreModule'
import ReservationFilters from '../ReservationFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    ReservationFilters,
  },
  directives: {
    Ripple,
  },
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    lotTypeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      user: store.state.auth.userData,

      required,
    }
  },

  methods: {
    getCreatedBy(item) {
      if (item.createdByNvs) {
        return item.createdByNvs.name
      }
      if (item.mainAgent) {
        return item.mainAgent.name
      }
      if (item.agent) {
        return item.agent.name
      }

      return '-'
    },
    getHoursMinsSeconds(endTime) {
      if (!endTime) {
        return 'Infinite'
      }
      const start = new Date()
      const end = new Date(endTime)
      const diff = end.getTime() - start.getTime()

      if (diff < 0) {
        return '00:00:00 left'
      }

      const hours = Math.floor(diff / 1000 / 60 / 60)
      const minutes = Math.floor(diff / 1000 / 60) % 60
      const seconds = Math.floor(diff / 1000) % 60 // Include seconds for better accuracy

      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} left`
    },
    hideFilter() {
      this.$refs.filter_current_reservations.hide(true)
    },
    showFilter() {
      this.$refs.filter_current_reservations.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    removeFromProductFilter(product) {
      const index = this.productFilter.indexOf(product)
      if (index > -1) {
        this.productFilter.splice(index, 1)
      }
    },
    removeFromLotTypeFilter(lotType) {
      const index = this.lotTypeFilter.indexOf(lotType)
      if (index > -1) {
        this.lotTypeFilter.splice(index, 1)
      }
    },
    resolveProductName(product) {
      // eslint-disable-next-line eqeqeq
      const productName = this.productOptions.find(prod => prod.code == product)
      return productName ? productName.title : ''
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.statusFilter = []
      this.productFilter = []
      this.lotTypeFilter = []
    },
    showReleaseWarning(id, customerName) {
      this.$swal({
        title: 'Are you sure you want to<br>release this lot?',
        html: `<p class='mt-1' />Releasing the lot before the scheduled<br>release date means that the customer <span class="text-bold-black">${customerName}</span> will no longer have a reservation,<br>and the lot will become available to others.<br>Are you sure you want to proceed?`,
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/wind.png'),
        input: 'textarea',
        inputPlaceholder: 'Add Remarks',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, release this lot',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
          input: 'reject-note-ta',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.isConfirmed) {
            this.$http.post(`reservation/agent/reservations/${id}/release`, {
              remarks: result.value || '',
            })
              .then(() => {
                this.$emit('emitCountReservation')
                this.fetchReservations()
                this.$swal({
                  title: 'Lot Released!',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    showNotAllowedWarning() {
      this.$swal({
        title: 'You do not have the necessary permissions to release a Staff Hold reservation.',
        html: 'Please check with your system administrator if you need further details.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: false,
        confirmButtonText: 'Ok, got it',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const RESERVATION_APP_STORE_MODULE_NAME = 'app-current-reservations'

    // Register module
    if (!store.hasModule(RESERVATION_APP_STORE_MODULE_NAME)) store.registerModule(RESERVATION_APP_STORE_MODULE_NAME, reservationStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(RESERVATION_APP_STORE_MODULE_NAME)) store.unregisterModule(RESERVATION_APP_STORE_MODULE_NAME)
    })

    const { canViewThisAction } = useAclUtils()

    const {
      fetchReservations,
      tableColumns,
      perPage,
      currentPage,
      totalReservations,
      dataMeta,
      perPageOptions,
      searchQuery,
      agentSearchQuery,
      sortBy,
      isSortDirDesc,
      refCurrentReservationsTable,
      refetchData,
      reservationData,

      toDeletedID,
      deleteReservation,

      // UI
      resolveReservationStatusVariant,

      // Extra Filters
      statusFilter,
      productFilter,
      lotTypeFilter,
      createdAtFilter,
    } = useCurrentReservationList()

    return {
      // Sidebar
      fetchReservations,
      tableColumns,
      perPage,
      currentPage,
      totalReservations,
      dataMeta,
      perPageOptions,
      searchQuery,
      agentSearchQuery,
      sortBy,
      isSortDirDesc,
      refCurrentReservationsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteReservation,
      reservationData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveReservationStatusVariant,

      // Extra Filters
      statusFilter,
      productFilter,
      lotTypeFilter,
      createdAtFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
